import React from 'react';
import { ConfigContext } from '../config-provider';
import AntdDivider from 'antd/es/divider/index';
const Divider = (props) => {
    const { prefixCls, ...otherProps } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const classPrefix = getPrefixCls('divider', prefixCls);
    return React.createElement(AntdDivider, { prefixCls: classPrefix, ...otherProps });
};
export default Divider;
